module.exports = __webpack_public_path__ + "images/home_point.e61e0e7979a523b136ad21cfb29eb8f6.png";